
import { Toaster } from "./components/ui/toaster"
import { TooltipProvider } from "./components/ui/tooltip"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import { ThemeProvider } from "./components/ThemeProvider"
import { ToastProvider } from "@/hooks/use-toast"
import { AuthProvider } from "./hooks/useAuth"
import Index from "./pages/Index"
import NotFound from "./pages/NotFound"
import DriverDashboard from "./pages/driver/Dashboard"
import DispatcherDashboard from "./pages/dispatcher/Dashboard"
import AuthPage from "./pages/AuthPage"

const queryClient = new QueryClient()

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <ToastProvider>
        <TooltipProvider>
          <BrowserRouter>
            <AuthProvider>
              <Toaster />
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/auth" element={<AuthPage />} />
                <Route path="/driver/dashboard" element={<DriverDashboard />} />
                <Route path="/dispatcher/dashboard" element={<DispatcherDashboard />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </AuthProvider>
          </BrowserRouter>
        </TooltipProvider>
      </ToastProvider>
    </ThemeProvider>
  </QueryClientProvider>
)

export default App
